import { Combobox } from '@ironscales/design-system'

export default Combobox

export const SIZES = Combobox.SIZES
export const STATUSES = Combobox.STATUSES
